// 3rd party
import * as React from 'react';

// Shared UI
import { useLocalization } from '@shared-ui/localization-context';

// UI Toolkit
import { UitkPrimaryButton } from 'uitk-react-button';

interface CopyLinkButtonProps {
  link?: string;
  onSuccess?: () => void;
  onFailure?: () => void;
}

function CopyLinkButton({ link, onSuccess, onFailure }: CopyLinkButtonProps) {
  const l10n = useLocalization();

  const [copied, setCopied] = React.useState(false);
  const buttonText = copied ? l10n.formatText('common.copied') : l10n.formatText('common.copy_link');

  function handleClick() {
    if (link) {
      setCopied(true);

      navigator.clipboard.writeText(link);

      setTimeout(() => {
        setCopied(false);
      }, 1500);

      onSuccess?.();
    } else {
      onFailure?.();
    }
  }

  return <UitkPrimaryButton onClick={handleClick}>{buttonText}</UitkPrimaryButton>;
}

export { CopyLinkButton };
